exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".total-table table {\n  width: 100%;\n}\n.total-table td {\n  @extend .para-medium;\n  padding: 0.4rem;\n}\n.total-table__left {\n  text-align: left;\n}\n.total-table__right {\n  text-align: right;\n  margin-left: 50px;\n}\n.total-table #taxPercent {\n  width: 10rem;\n}\n@media (max-width: 480px) {\n  .total-table td {\n    font-size: 1.55rem;\n  }\n}\n", ""]);

// exports
